import { render } from "./PlayerProfileFullImage.vue?vue&type=template&id=722d5d74"
import script from "./PlayerProfileFullImage.vue?vue&type=script&lang=js"
export * from "./PlayerProfileFullImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/windowOverlay/PlayerProfileFullImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "722d5d74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('722d5d74', __exports__)) {
    api.reload('722d5d74', __exports__)
  }
  
  module.hot.accept("./PlayerProfileFullImage.vue?vue&type=template&id=722d5d74", () => {
    api.rerender('722d5d74', render)
  })

}


export default __exports__